import { render, staticRenderFns } from "./RootCategoryNavigation.vue?vue&type=template&id=ea1e3444&scoped=true"
import script from "./RootCategoryNavigation.vue?vue&type=script&lang=ts"
export * from "./RootCategoryNavigation.vue?vue&type=script&lang=ts"
import style0 from "./RootCategoryNavigation.vue?vue&type=style&index=0&id=ea1e3444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1e3444",
  null
  
)

export default component.exports